import { render, staticRenderFns } from "./email-update-popup.html?vue&type=template&id=cd0615ae&scoped=true&external"
import script from "./email-update-popup.js?vue&type=script&lang=js&external"
export * from "./email-update-popup.js?vue&type=script&lang=js&external"
import style0 from "./email-update-popup.scss?vue&type=style&index=0&id=cd0615ae&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd0615ae",
  null
  
)

export default component.exports